import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from '../../../assets/img/about/aboutOne/img1.webp';

function AboutOne(){
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility>
        <div className={`aboutOne ${isVisible ? 'visible' : ''}`}>
            <VisibilitySensor partialVisibility={false}>
            <div className="aboutOneC1">
                <img className={`${isVisible ? 'visible' : ''}`} src={img1} alt="" width={'500px'}/>
                <div className="text">
                    <h1 className={`${isVisible ? 'visible' : ''}`}>{t("about_one_title")}</h1>
                    <p className={`${isVisible ? 'visible' : ''}`}>{t("about_one_text")}</p>
                </div>
            </div>
            </VisibilitySensor>
        </div>
        </VisibilitySensor>
    )
}

export default AboutOne;